import routingHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/routing-header.png';
import routingSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/routing-section1.png';
import routingSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/routing-section2.png';
import routingSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/routing-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_ROUTING: PageblockData = {
  headerData: {
    headerText: 'Boost pipeline speed with automated assignment & routing',
    subHeaderText:
      'Create and manage groups, territories, and assignment rules for any Salesforce object.',
    imgSrc: routingHeader,
    imgAlt: 'Routing header',
    name: 'Routing',
  },
  pageTitle: 'Effortlessly assign leads and opportunities with smart routing',
  section1: {
    imgSrc: routingSection1,
    imgAlt: 'Routing section img',
    title: 'Customizable assignment logic',
    content:
      'Create custom assignment rules tailored to any scenario, ensuring leads, opportunities, and other records connect with the right person based on your specific Salesforce setup.',
  },
  section2: {
    imgSrc: routingSection2,
    imgAlt: 'Routing section 2 img',
    title: 'Optimize territory & group management',
    content:
      'Define territories, teams, and workload limits to balance assignments efficiently. Quickly adjust rules based on evolving sales strategies, ensuring fair distribution across geographies, roles, or custom criteria.',
  },
  section3: {
    imgSrc: routingSection3,
    imgAlt: 'Routing section 3 img',
    title: 'Automate record assignment for faster routing',
    content:
      'Ensure every record reaches the right team member instantly using customizable routing criteria, round robin distribution, and scheduled assignments—reducing manual effort and improving response times.',
  },
};
